import React from 'react'
import { collection } from "firebase/firestore";
import { db } from '../../firebase.js'
import SendQuestionsForm from './SendQuestionsForm'
import d11 from './NewQuestion.module.css'
import Card from '../ui/Card'

import { IoArrowBack } from 'react-icons/io5'
function NewQuestion(props) {
    return (
        <Card>
            <div className={d11.overlay}>
                <button className={d11.backButton} onClick={props.onClick}><IoArrowBack size='30' /></button>

                <div className={d11.pageText}>Ask a Question </div>

                <SendQuestionsForm close={props.onClick} collectionRef={collection(db, "questions")} targetTeacher={props.targetTeacher} />
            </div>
        </Card>
    )
}

export default NewQuestion
